module.exports = __webpack_public_path__ + "img/muslera.58eda76d.png";